import React from 'react'
import useNeedMarkTimes from 'common/hooks/useNeedMarkTimes'
import TiledSelect from 'baseComponent/tiledSelect'
import Select from 'meinian-package/src/baseComponent/select'

export default (props) => {
  const { value, otherValue, onChange, trigger } = props
  const switchOption = useNeedMarkTimes({ inspirationId: props.inspirationId, needMarkTimes: props.needMarkTimes })

  const _onChange = (_val, item) => {
    const temp = _val ? _val.split(',')[0] : null
    onChange?.(temp, item)
  }
  const _value = otherValue ? `${value},${otherValue}` : `${value}`
  return <Select
    data={switchOption}
    value={value ? _value : null}
    onChange={_onChange}
    placeholder="审核状态"
    trigger={trigger}
  />
}

export const TiledMark = ({ inspirationId, needMarkTimes, value, otherValue, onChange, style, className }) => {
  const switchOption = useNeedMarkTimes({ inspirationId, needMarkTimes })
  const _value = otherValue ? `${value},${otherValue}` : `${value}`
  const _onChange = (_val, item) => {
    const temp = _val ? _val.split(',')[0] : null
    onChange?.(temp, item)
  }
  return <TiledSelect
    label="审核状态"
    options={switchOption}
    onChange={_onChange}
    value={value ? _value : null}
    style={style}
    className={className}
  />
}
